export default "__VITE_ASSET__CcYXB4tm__"